import React from 'react';
import { ArrowRight, Star } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Hero = () => {
  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${businessInfo.whatsapp}?text=Hola! Me gustaría sacar un turno para mi mascota.`, '_blank');
  };

  return (
    <section id="inicio" className="relative pt-20 min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1604152971040-e2569ed6964c?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Happy pet with owner"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-teal-900/90 via-teal-800/80 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-2xl">
          {/* Rating Badge */}
          <div className="inline-flex items-center gap-2 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg mb-6 animate-in fade-in slide-in-from-bottom-4 duration-700">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="text-sm font-semibold text-gray-800">
              {businessInfo.rating} ({businessInfo.totalReviews} reseñas)
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight animate-in fade-in slide-in-from-bottom-6 duration-700 delay-100">
            {businessInfo.slogan}
          </h1>

          {/* Description */}
          <p className="text-xl md:text-2xl text-teal-50 mb-8 leading-relaxed animate-in fade-in slide-in-from-bottom-8 duration-700 delay-200">
            Atención veterinaria profesional con amor, empatía y dedicación para tu compañero más fiel.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-in fade-in slide-in-from-bottom-10 duration-700 delay-300">
            <button
              onClick={handleWhatsAppClick}
              className="group inline-flex items-center justify-center gap-2 px-8 py-4 bg-teal-500 text-white text-lg font-semibold rounded-xl hover:bg-teal-600 transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105"
            >
              Sacar Turno
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => document.getElementById('contacto').scrollIntoView({ behavior: 'smooth' })}
              className="inline-flex items-center justify-center px-8 py-4 bg-white/95 backdrop-blur-sm text-teal-700 text-lg font-semibold rounded-xl hover:bg-white transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              Contacto
            </button>
          </div>

          {/* Info Pills */}
          <div className="mt-12 flex flex-wrap gap-4 animate-in fade-in slide-in-from-bottom-12 duration-700 delay-400">
            <div className="px-4 py-2 bg-white/90 backdrop-blur-sm rounded-lg shadow-md">
              <p className="text-sm font-medium text-gray-600">Horario</p>
              <p className="text-sm font-bold text-teal-700">{businessInfo.hours}</p>
            </div>
            <div className="px-4 py-2 bg-white/90 backdrop-blur-sm rounded-lg shadow-md">
              <p className="text-sm font-medium text-gray-600">Ubicación</p>
              <p className="text-sm font-bold text-teal-700">CABA, Buenos Aires</p>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Wave */}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
          <path d="M0 0L60 10C120 20 240 40 360 46.7C480 53 600 47 720 43.3C840 40 960 40 1080 46.7C1200 53 1320 67 1380 73.3L1440 80V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z" fill="white" />
        </svg>
      </div>
    </section>
  );
};

export default Hero;